import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import msgConstants from '../../../../constants/msgConstants'
import parceiroManager from '../../../../services/api/parceiro/parceiroManager'
import { loadingReset, loadingUpdate } from '../../../../store/actions/loadingAction'
import { ObterListaStatusParceiroResponse, StatusParceiroRequest } from '../../../../types/parceiroApiTypes'
import { itemStatusStyles } from './ItemStatus.style'
import { ItemStatusProps } from './ItemStatus.View'

export function itemStatusIO({ parceiroId, atualizarDados }: ItemStatusProps) {
  const dispatch = useDispatch()
  const [abrirModalEditar, setAbrirModalEditar] = useState(false)
  const [ativarIconeAncora, setAtivarIconeAncora] = useState<null | HTMLElement>(null)

  const handleAtivarIconeAncora = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAtivarIconeAncora(event.currentTarget)
  }

  const handleFecharIconeAncora = () => {
    setAtivarIconeAncora(null)
  }

  function abrirModalEdicao() {
    setAbrirModalEditar(true)
  }

  function fecharModalEdicao() {
    setAbrirModalEditar(false)
  }

  const handleAtivarIconeAncoraModalEdicao = () => {
    setAtivarIconeAncora(null)
    abrirModalEdicao()
  }

  const desativarStatusParceiro = (item: ObterListaStatusParceiroResponse) => {
    dispatch(loadingUpdate(true))
    setAtivarIconeAncora(null)
    const dataEdit = {
      ativo: !item.ativo,
      nomeStatusParceiro: item.nomeStatusParceiro,
      listaStatusTracking: item.listaStatusTracking,
      listaStatusEfacil: item.listaStatusEfacil,
      verificarOcorrencia: item.verificarOcorrencia
    } as StatusParceiroRequest

    parceiroManager
      .editarStatusParceiro(parceiroId, item.id, dataEdit)
      .then(() => {
        toast.success(msgConstants.USO_GENERICO.edicao_sucesso)
        atualizarDados()
      })
      .catch((error: Error) => {
        toast.error(error.message)
      })
      .finally(() => {
        dispatch(loadingReset())
      })
  }

  return {
    styles: itemStatusStyles,
    abrirModalEditar,
    fecharModalEdicao,
    handleAtivarIconeAncoraModalEdicao,
    ativarIconeAncora,
    handleAtivarIconeAncora,
    handleFecharIconeAncora,
    desativarStatusParceiro
  }
}
export type ItemStatusIO = ReturnType<typeof itemStatusIO>
